// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import DashboardOutlined from '/root/airange/node_modules/.pnpm/@ant-design+icons@4.8.3_react-dom@19.2.7_react@19.2.7__react@19.2.7/node_modules/@ant-design/icons/es/icons/DashboardOutlined';
export default { DashboardOutlined };
